export const ar = {
  'ad.label': 'إعلان',
  'ad.sponsored_by': 'برعاية {advertiser}',
  'ad.visit': 'زيارة',
  'cookies.preferences': 'تفضيلات ملفات تعريف الارتباط',
  'cookies.title': 'خصوصيتك تحت سيطرتك',
  'cookies.description': 'نستخدم التخزين الضروري لعمل Albambam. لن نفعّل التحليلات أو التسويق إلا بإذنك. يمكنك سحبه في أي وقت. اقرأ',
  'cookies.privacy_link': 'سياسة الخصوصية',
  'cookies.close': 'إغلاق التفضيلات',
  'cookies.necessary': 'ضرورية',
  'cookies.necessary_desc': 'الجلسة والأمان واللغة والتفضيلات الأساسية.',
  'cookies.analytics': 'التحليلات',
  'cookies.analytics_desc': 'قياس مجهول للاستخدام لتحسين الخدمة.',
  'cookies.marketing': 'التسويق',
  'cookies.marketing_desc': 'تخصيص الإعلانات وقياس الحملات.',
  'cookies.configure': 'تكوين',
  'cookies.reject': 'رفض الاختيارية',
  'cookies.save': 'حفظ التحديد',
  'cookies.accept': 'قبول الكل',
  'lang.selector_label': 'اللغة',
  'lang.changed': 'تم تغيير اللغة',
  'nav.home': 'الرئيسية',
  'nav.categories': 'الفئات',
  'nav.shorts': 'Shorts',
  'nav.friends': 'الصداقة',
  'nav.upload': 'رفع',
  'nav.profile': 'الملف الشخصي',
  'nav.login': 'تسجيل الدخول',
  'common.signed_in': 'تم تسجيل الدخول',
  'common.error': 'خطأ',
  'topbar.search_placeholder': 'ابحث عن فيديوهات، صنّاع محتوى...',
  'legal.terms': 'الشروط',
  'legal.privacy': 'الخصوصية',
  'nav.admin': 'الإدارة',
  'nav.logout': 'تسجيل الخروج',
  'admin.tab.payments': 'المدفوعات',
  'admin.payments.title': 'المدفوعات',
  'cats.title': 'الفئات',
  'cats.all': 'الكل',
  'cats.adult_title': 'فئات +18',
  'cats.empty': 'لا توجد فيديوهات في هذه الفئة.',
  'friends.block_confirm': 'حظر هذا الصديق؟ لن تتمكن بعد الآن من الدردشة أو رؤية بعضكما كأصدقاء.',
  'friends.accepted': 'أنتما الآن أصدقاء!',
  'friends.title': 'الصداقة',
  'friends.subtitle': 'فقط من يتابعون بعضهم البعض بشكل متبادل يصبحون أصدقاء ويمكنهم الدردشة بشكل خاص.',
  'friends.unread_count_label': '{n} رسائل غير مقروءة',
  'friends.blocked_users_title': 'المستخدمون المحظورون',
  'friends.unblock_user': 'إلغاء الحظر',
  'friends.requests_title': 'طلبات الدردشة',
  'friends.request_badge': 'طلب',
  'friends.request_accept': 'قبول',
  'friends.request_ignore': 'تجاهل',
  'friends.empty_title': 'لا أصدقاء بعد',
  'friends.empty_subtitle': 'تابع شخصًا وتابعك بالمقابل لفتح الدردشة الخاصة.',
  'friends.attach_image': 'صورة',
  'friends.shared_video_label': 'شارك فيديو',
  'friends.select_conversation': 'اختر صديقًا لبدء الدردشة',
  'friends.block_user': 'حظر',
  'friends.no_messages_yet': 'لا رسائل بعد. قل مرحبًا!',
  'friends.message_placeholder': 'اكتب رسالة...',
  'section.trending': 'الرائج',
  'section.shorts': 'Shorts',
  'section.for_you': 'لك',
  'home.hero.badge': 'مرحبًا بك في Albambam',
  'home.hero.title_1': 'فيديوهات قصيرة.',
  'home.hero.title_2': 'صنّاع محتوى حقيقيون.',
  'home.hero.subtitle': 'شاهد وشارك واربح. ارفع فيديوهاتك واكتشف مواهب جديدة في كل فئة.',
  'home.hero.cta_shorts': 'مشاهدة Shorts',
  'home.hero.cta_trending': 'الرائج',
  'home.shorts.see_all': 'عرض الكل',
  'home.empty.title': 'لا فيديوهات بعد',
  'home.empty.subtitle': 'عندما يرفع صنّاع المحتوى محتوى، سيظهر هنا.',
  'live.send_diamonds': 'إرسال ماسات',
  'live.buy': 'شراء',
  'live.chat': 'الدردشة',
  'live.type_message': 'اكتب رسالة...',
  'live.send': 'إرسال',
  'auth.success_google': 'تم تسجيل الدخول عبر Google',
  'auth.fail_google': 'جلسة Google غير صالحة',
  'auth.success_login': 'تم تسجيل الدخول',
  'auth.success_register': 'تم إنشاء الحساب',
  'auth.login_tab': 'تسجيل الدخول',
  'auth.register_tab': 'إنشاء حساب',
  'auth.email': 'البريد الإلكتروني',
  'auth.password': 'كلمة المرور',
  'auth.submit_login_loading': 'جارٍ تسجيل الدخول...',
  'auth.submit_login': 'تسجيل الدخول',
  'auth.name': 'الاسم',
  'auth.submit_register_loading': 'جارٍ الإنشاء...',
  'auth.submit_register': 'إنشاء حساب',
  'auth.or': 'أو',
  'legal.privacy_title': 'سياسة الخصوصية',
  'search.title': 'نتائج البحث عن «{q}»',
  'search.count': '{n} فيديوهات',
  'search.empty': 'لا نتائج.',
  'series.load_error': 'تعذّر تحميل المسلسل',
  'series.unlocked': 'تم فتح المسلسل',
  'series.purchase_error': 'تعذّر بدء عملية الشراء',
  'series.restricted': 'وصول مقيّد',
  'series.configure_access': 'تكوين الوصول',
  'series.language_all': 'كل اللغات',
  'series.episode_count': '{n} حلقات',
  'series.buy': 'شراء المسلسل',
  'series.filter_language': 'تصفية حسب اللغة',
  'series.no_episodes': 'لم تُنشر أي حلقات بعد.',
  'series.episode_number': 'الحلقة {n}',
  'legal.terms_title': 'الشروط والأحكام',
  'lang.ca': 'الكتالانية',
  'lang.en': 'الإنجليزية',
  'lang.es': 'الإسبانية',
  'lang.fr': 'الفرنسية',
  'lang.de': 'الألمانية',
  'lang.it': 'الإيطالية',
  'lang.eu': 'الباسكية',
  'lang.gl': 'الغاليسية',
  'lang.zh': 'الصينية',
  'lang.other': 'أخرى',
  'lang.vi': 'الفيتنامية',
  'lang.ja': 'اليابانية',
  'lang.ko': 'الكورية',
  'lang.ru': 'الروسية',
  'lang.ro': 'الرومانية',
  'lang.ar': 'العربية',
  'lang.tr': 'التركية',
  'lang.pl': 'البولندية',
  'lang.ms': 'الملايوية',
  'lang.ta': 'التاميلية',
  'upload.series_title_error': 'أدخل عنوان المسلسل',
  'upload.series_adult_category_error': 'اختر فئة +18 للمسلسل',
  'upload.series_created': 'تم إنشاء المسلسل',
  'upload.series_create_error': 'تعذّر إنشاء المسلسل',
  'upload.err_file': 'اختر ملف فيديو صالحًا',
  'upload.err_title': 'ضع عنوانًا',
  'upload.series_select_error': 'اختر أو أنشئ مسلسلًا',
  'upload.trailer_target_error': 'اختر الفيديو أو المسلسل الخاص بالعرض الترويجي',
  'upload.price_error': 'أدخل سعرًا صالحًا بحد أدنى 0.50 يورو.',
  'upload.adult_category_error': 'اختر فئة للبالغين',
  'upload.success': 'تم رفع الفيديو بنجاح',
  'upload.title_h': 'رفع فيديو',
  'upload.kind': 'نوع المنشور',
  'upload.kind_video': 'فيديو مستقل',
  'upload.kind_episode': 'حلقة من مسلسل',
  'upload.kind_trailer': 'عرض ترويجي عام في Shorts',
  'upload.series': 'مسلسل',
  'upload.series_select': 'اختر مسلسلًا',
  'upload.episode': 'حلقة',
  'upload.series_new_title': 'عنوان مسلسل جديد',
  'upload.series_create': 'إنشاء مسلسل',
  'upload.series_adult': 'مسلسل +18',
  'upload.series_premium': 'مسلسل مميز',
  'upload.series_adult_category': 'فئة +18 للمسلسل',
  'upload.series_price': 'سعر الحلقة والحزمة (يورو)',
  'upload.trailer_for': 'العرض الترويجي يقدّم',
  'upload.trailer_select': 'اختر فيديو أو مسلسلًا',
  'upload.video_prefix': 'فيديو',
  'upload.file_label': 'ملف الفيديو (MP4، بحد أقصى 1 جيجابايت)',
  'upload.file_pick': 'انقر لاختيار فيديو',
  'upload.thumb_label': 'الصورة المصغّرة (اختياري)',
  'upload.video_title': 'العنوان',
  'upload.description': 'الوصف',
  'upload.category': 'الفئة',
  'upload.is_short': 'هو Short (عمودي)',
  'upload.paid_video': 'فيديو مدفوع',
  'upload.adult_content': 'محتوى +18',
  'upload.video_language': 'لغة الفيديو',
  'upload.individual_price': 'سعر مشاهدة هذا الفيديو (يورو)',
  'upload.paid_video_help': 'سيشتري المشاهد وصولًا دائمًا لهذا الفيديو فقط. الحد الأدنى للسعر هو 0.50 يورو.',
  'upload.adult_category': 'فئة البالغين',
  'upload.uploading': 'جارٍ الرفع {n}%',
  'upload.submit': 'رفع الفيديو',
  'user.followers': 'متابعون',
  'user.following': 'يتابعهم',
  'user.follow': 'متابعة',
  'user.chat_open': 'دردشة',
  'user.request_sent': 'تم إرسال الطلب',
  'user.send_message': 'إرسال رسالة',
  'user.followers_title': 'المتابعون',
  'user.following_title': 'المتابَعون',
  'user.unfollow': 'إلغاء المتابعة',
  'user.request_title': 'طلب دردشة',
  'user.request_subtitle': 'يمكنك إرسال رسالة واحدة فقط. إذا قبل الطلب، ستصبحان أصدقاء ويمكنك الدردشة.',
  'user.request_placeholder': 'اكتب رسالتك...',
  'user.request_send': 'إرسال الطلب',
  'shorts.login_for_like': 'سجّل الدخول للإعجاب',
  'watch.share_copied': 'تم نسخ الرابط',
  'watch.delete_confirm': 'حذف هذا التعليق؟',
  'ad.skip_in': 'التخطي خلال {n} ثانية',
  'ad.skip': 'تخطي الإعلان',
  'watch.share': 'مشاركة',
  'friends.share_video': 'شارك فيديو',
  'friends.send': 'إرسال',
  'watch.comments': 'التعليقات',
  'watch.write_comment': 'اكتب تعليقًا...',
  'watch.publish': 'نشر',
  'watch.login_to_comment': 'يجب تسجيل الدخول للتعليق.',
  'watch.login_btn': 'سجّل الدخول للتعليق',
  'watch.no_comments': 'لا تعليقات بعد.',
  'watch.related': 'ذات صلة',
  'nav.trending': 'الرائج',
  'friends.follow_option_only_follow': 'متابعة',
  'friends.follow_option_friends': 'أصدقاء',
  'watch.like': 'إعجاب',
  'watch.views_short': '{n} مشاهدات',
  'shorts.empty.title': 'لا Shorts بعد',
  'shorts.empty.subtitle': 'ارفع فيديو قصيرًا لبدء القسم.',
  'shorts.share': 'مشاركة',
  'auth.continue_google': 'المتابعة عبر Google',
  'upload.is_premium': 'مميز',
  'upload.price': 'السعر (€)',
  'upload.err_select': 'اختر فيديو',
  'profile.upload_btn': 'رفع فيديو',
  'profile.tab_videos': 'فيديوهاتي ({n})',
  'profile.tab_history': 'السجل',
  'profile.tab_recos': 'التوصيات',
  'profile.no_videos': 'لم ترفع أي فيديوهات بعد.',
  'profile.no_history': 'لم تشاهد أي فيديوهات بعد.',
  'profile.no_recos': 'شاهد بعض الفيديوهات لتلقي توصيات.',
  'profile.likes': 'إعجابات',
  'profile.views': 'مشاهدات',
  'wallet.title': 'المحفظة',
  'wallet.rate_label': 'السعر',
  'wallet.min_label': 'الحد الأدنى للسحب',
  'wallet.amount_label': 'المبلغ المطلوب سحبه',
  'wallet.withdraw_btn': 'طلب سحب',
  'wallet.history_title': 'سجل الطلبات',
  'wallet.success': 'تم إنشاء الطلب',
  'wallet.bad_amount': 'مبلغ غير صالح',
  'wallet.per_view': '{rate} {cur}/مشاهدة',
  'admin.title': 'الإدارة',
  'admin.stats.users': 'المستخدمون',
  'admin.stats.videos': 'الفيديوهات',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'المشاهدات',
  'admin.tab.videos': 'الفيديوهات',
  'admin.tab.ads': 'الإعلانات',
  'admin.tab.users': 'المستخدمون',
  'admin.tab.withdrawals': 'السحوبات',
  'admin.tab.config': 'الإعدادات',
  'admin.tab.translations': 'الترجمات',
  'tbl.title': 'العنوان',
  'tbl.creator': 'الصانع',
  'tbl.category': 'الفئة',
  'tbl.type': 'النوع',
  'tbl.views': 'المشاهدات',
  'tbl.likes': 'الإعجابات',
  'tbl.status': 'الحالة',
  'tbl.actions': 'الإجراءات',
  'tbl.placement': 'الموضع',
  'tbl.advertiser': 'المعلن',
  'tbl.impressions': 'ظهور',
  'tbl.clicks': 'نقرات',
  'tbl.active': 'نشط',
  'tbl.name': 'الاسم',
  'tbl.email': 'البريد',
  'tbl.role': 'الدور',
  'tbl.wallet': 'المحفظة',
  'tbl.amount': 'المبلغ',
  'tbl.date': 'التاريخ',
  'tbl.user': 'المستخدم',
  'video.video': 'فيديو',
  'video.short': 'Short',
  'action.show': 'نشر',
  'action.hide': 'إخفاء',
  'action.delete_confirm_video': 'حذف الفيديو؟',
  'ad.create_h': 'إنشاء إعلان',
  'ad.title_label': 'العنوان',
  'ad.image_label': 'رابط الصورة',
  'ad.target_label': 'الرابط المستهدف',
  'ad.advertiser_label': 'المعلن',
  'ad.placement_label': 'الموضع',
  'ad.placement.banner': 'بانر (الموقع)',
  'ad.placement.preroll': 'قبل التشغيل (قبل الفيديو)',
  'ad.placement.overlay': 'طبقة علوية (داخل الفيديو)',
  'ad.active': 'نشط',
  'ad.create_btn': 'إنشاء',
  'ad.success_create': 'تم إنشاء الإعلان',
  'ad.delete_confirm': 'حذف الإعلان؟',
  'users.make_admin': 'ترقية إلى مشرف',
  'users.remove_admin': 'إزالة الإشراف',
  'wd.approve': 'موافقة',
  'wd.reject': 'رفض',
  'wd.mark_paid': 'تحديد كمدفوع',
  'wd.empty': 'لا طلبات',
  'cfg.title': 'إعدادات الدفع',
  'cfg.rate_label': 'الدفع لكل مشاهدة ({cur})',
  'cfg.min_label': 'الحد الأدنى للسحب ({cur})',
  'cfg.currency': 'العملة',
  'cfg.save': 'حفظ',
  'cfg.saved': 'تم حفظ الإعدادات',
  'trans.title': 'اللغات والترجمات',
  'trans.intro': 'ارفع ملف JSON بترجمات لأي رمز لغة (مثل ja أو pt أو zh). يجب أن يحتوي الملف على خريطة مسطّحة من مفتاح ← نص.',
  'trans.code_label': 'رمز اللغة (مثل ja أو pt-BR أو zh)',
  'trans.name_label': 'الاسم (بتلك اللغة)',
  'trans.file_label': 'ملف JSON للترجمات',
  'trans.upload': 'رفع',
  'trans.uploaded': 'تم حفظ الترجمات',
  'trans.delete': 'حذف',
  'trans.delete_confirm': 'حذف هذه اللغة؟',
  'trans.builtin': 'مدمج',
  'trans.custom': 'مخصّص',
  'trans.empty_custom': 'لا لغات مخصّصة بعد.',
  'common.cancel': 'إلغاء',
  'common.loading': 'جارٍ التحميل...',
  'common.too_fast': 'بسرعة كبيرة، يرجى الانتظار لحظة',
  'time.few_seconds': 'قبل ثوانٍ قليلة',
  'time.min': 'قبل {n} دقيقة',
  'time.h': 'قبل {n} ساعة',
  'time.d': 'قبل {n} يوم',
  'time.w': 'قبل {n} أسبوع',
  'time.mo': 'قبل {n} شهر',
  'time.y': 'قبل {n} سنة',
  'brand.tagline': 'فيديوهات قصيرة. صنّاع محتوى حقيقيون.',
  'live.section': 'بث مباشر',
  'live.start': 'بدء بث مباشر',
  'live.end': 'إنهاء البث المباشر',
  'live.join': 'الانضمام إلى البث المباشر',
  'live.chat_placeholder': 'اكتب رسالة...',
  'live.diamond': 'ماس',
  'live.buy_access': 'شراء الوصول',
  'live.save_recording': 'حفظ التسجيل',
};
